const ADMIN_LIST_GRID = 'ADMIN_LIST_GRID';

export {
  ADMIN_LIST_GRID,
}